import { RevisionsScoreChartDataSource } from "../../../types";

export const SCORE_SERIES_TITLE = ["Price", "EPS RS", "Sales RS"];

export const OPTIONS: Record<RevisionsScoreChartDataSource, string> = {
	[RevisionsScoreChartDataSource.ZACKS]: "Source 1",
	[RevisionsScoreChartDataSource.FINNHUB]: "Source 2",
};

export const OPTIONS_HOVER: Record<RevisionsScoreChartDataSource, string> = {
	[RevisionsScoreChartDataSource.ZACKS]: "Zacks",
	[RevisionsScoreChartDataSource.FINNHUB]: "Finnhub",
};
